/* eslint-disable react/jsx-props-no-spreading */
import type { AppProps } from 'next/app';
import { Provider } from 'react-redux';
import { createReduxWrapper } from '@doda/common/src/redux/utils/createReduxWrapper';
import { rootReducer } from './redux/store';
import { initServerSideProps } from './initServerSideProps';
import { JobSearchDetail } from './screens/JobSearchDetailScreen';

const wrapper = createReduxWrapper(rootReducer);

export const getServerSideProps =
  wrapper.getServerSideProps(initServerSideProps);

/**
 *
 */
export default function Index(props: Omit<AppProps, 'Component'>) {
  const {
    store,
    props: { pageProps },
  } = wrapper.useWrappedStore(props);
  // 410ステータスの場合の対応 - 不要なレンダリングをスキップ
  if (!pageProps.job) return null;

  return (
    <Provider store={store}>
      <JobSearchDetail {...pageProps} />
    </Provider>
  );
}
